import Furniture from './Furniture';

const STATE_TO_FLOWER = 1;
const STATE_IDLE = 2;
const STATE_TO_HIVE = 3;

export default class Bee extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.beeTree;
    this.onFlower = false;
    this.timeToReturn = 10;

    this.asset.setMixByName('fly', 'idle', 0.2);
    this.asset.setMixByName('idle', 'fly', 0.2);

    this.setAnim('fly');
  }

  init(x, y) {
    this.active = true;
    this.visible = true;
    this.goHome = false;
    this.homePos = {};
    this.x = this.homePos.x = x;
    this.y = this.homePos.y = y;

    this.rootBone.scaleX = 1;

    this.state = STATE_TO_FLOWER;
    this.timeToReturn = 10;
  }

  setTarget(targetPos, targetId) {
    this.targetId = targetId;

    // generate path
    const dx = targetPos.x - this.homePos.x;
    const dy = targetPos.y - this.homePos.y;
    this.path = { x: [], y: [] };
    this.path.x.push(this.homePos.x);
    this.path.y.push(this.homePos.y);
    this.path.x.push(this.homePos.x + dx * 0.1);
    this.path.y.push(this.homePos.y + dy * 0.9);
    this.path.x.push(this.homePos.x + dx * 0.8);
    this.path.y.push(this.homePos.y + dy * 0.8);
    this.path.x.push(targetPos.x);
    this.path.y.push(targetPos.y);

    this.points = [];
    for (let i = 0; i <= 100; i++) {
      const x0 = Phaser.Math.catmullRomInterpolation(this.path.x, i / 100);
      const y0 = Phaser.Math.catmullRomInterpolation(this.path.y, i / 100);
      this.points.push({ x: x0, y: y0 });
    }

    this.time = 0;
  }

  handleInputDown() {
    if (this.onFlower) {
      this.returnHome();
    }
  }

  returnHome() {
    this.onFlower = false;
    this.rootBone.scaleX = -1;
    this.setAnim('fly');
    this.state = STATE_TO_HIVE;
  }

  step(dt) {
    if (this.active) {
      super.step(dt);
    }

    if (this.onFlower) {
      this.timeToReturn -= dt;
      if (this.timeToReturn <= 0) {
        this.returnHome();
      }
    }

    if (this.state === STATE_TO_FLOWER) {
      this.time += dt * 0.4;
      if (this.time <= 1) {
        const ind = Math.round(this.time * 100);
        const pt = this.points[ind];
        this.x = pt.x;
        this.y = pt.y;
      } else {
        this.state = STATE_IDLE;
        this.time = 1;
        this.onFlower = true;
        this.setAnim('idle');
      }
    } else if (this.state === STATE_TO_HIVE) {
      this.time -= dt * 0.4;
      if (this.time >= 0) {
        const ind = Math.round(this.time * 100);
        const pt = this.points[ind];
        this.x = pt.x;
        this.y = pt.y;
      } else {
        this.state = STATE_IDLE;
        this.beeTree.removeBee(this);
      }
    }
  }

  removeMe() {
    this.active = false;
    this.visible = false;
  }

  //
  serialize() {
    return null;
  }
}
